<div class="map-wrapper">
  <div class="map-loader-overlay" *ngIf="isLoading">
    <div class="loader-content">
      <mat-spinner diameter="40"></mat-spinner>
      <p class="loader-text">Loading Map...</p>
    </div>
  </div>
  <div id="windy"></div>
</div>
  <div class="map-legend-wrapper">
        <div class="table-hint map-legend">
          <mat-icon class="hint-icon">info</mat-icon>

          <div class="legend-items">
            <span class="legend-item">
              <span class="legend-ship-icon laden"></span>
              Laden
            </span>

            <span class="legend-item">
              <span class="legend-ship-icon ballast"></span>
              Ballast
            </span>
          </div>
        </div>
      </div>